import { render, staticRenderFns } from "./RoomDetails.vue?vue&type=template&id=77015f98&scoped=true&"
import script from "./RoomDetails.vue?vue&type=script&lang=ts&"
export * from "./RoomDetails.vue?vue&type=script&lang=ts&"
import style0 from "./RoomDetails.vue?vue&type=style&index=0&id=77015f98&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77015f98",
  null
  
)

export default component.exports